import { Outlet, useOutletContext } from "react-router-dom";

type ProfileOutletContext = {
  setLoaderState: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function TeamUsersTab() {
  const { setLoaderState } = useOutletContext<ProfileOutletContext>();
  
  return (
    <Outlet context={{ setLoaderState }} />
  );
}
